import * as React from 'react';
import { StatelessInvoiceLineItems } from './invoice-line-items';
import { getInvoiceAdditionalDetails, InvoiceWithLineItemsPPC } from '../invoice-page-utils';
import { EntityWithNotes } from '@atlassian/cssxp-types-audit';
import { AuditNotes } from '@css-xp/base';

interface Props {
  invoice: InvoiceWithLineItemsPPC;
}
export const InvoiceDetail = (props: Props) => {
  const auditTrailProps = {
    entityName: EntityWithNotes.INVOICE,
    id: props.invoice.id,
  };

  return (
    <div className="billing-details" data-testid="billing-details">
      {getInvoiceAdditionalDetails(props.invoice)}
      <StatelessInvoiceLineItems invoice={props.invoice} />
      <AuditNotes {...auditTrailProps} />
    </div>
  );
};
